module.exports = __webpack_public_path__ + "img/esc_1_act_1.d9527312.png";